module.exports = __webpack_public_path__ + "img/symbol_6.35bead8e.png";